// extracted by mini-css-extract-plugin
export default {"root":"SizeDropdown_root__+gsBl"};